export const getNumberWithOrdinal = (n: number) => {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return n + (s[(v - 20) % 10] || s[v] || s[0])!;
};
